import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import cn from 'classnames';

import { TextRedactor } from '../Elements';
import TooltipAlert from '../../../../pages/CreateFirstRelease/parts/TooltipAlert/TooltipAlert';

import { textToDateOrTime } from 'utils/common';

import classes from './WidgetReleaseWithRedactor.module.scss';

const WidgetReleaseWithRedactor = ({
  date,
  title,
  sourse,
  text,
  onCancel,
  className,
  headerText,
  onClickOk,
  nameInput,
  newClearRelease,
  disabledBottomPanel,
  onClickEdit
}) => {
  return (
    <div className={cn(classes.widgetRelease, className)}>
      <p className={classes.date}>{textToDateOrTime(date, 'date')}</p>
      <h2 className={cn(classes.title)}>{title}</h2>
      <div className={classes.middleBox}>
        <a
          href={sourse}
          // eslint-disable-next-line
          target="_blank"
          className={cn(classes.link, classes.hiddenText, classes.sourse)}
        >
          {sourse}
        </a>
      </div>
      <Media
        queries={{
          small: '(max-width: 1279px)'
        }}
      >
        {matches =>
          matches.small && (
            <div className={classes.tooltipAlert}>
              <TooltipAlert redactor onClickEdit={onClickEdit} />
            </div>
          )
        }
      </Media>
      <div
        className={classes.text}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
      {!disabledBottomPanel && <div className={classes.whiteBlock}></div>}
      <TextRedactor
        className={classes.nameForm}
        onCancel={onCancel}
        onClickOk={onClickOk}
        value={nameInput}
        newClearRelease={newClearRelease}
        headerText={headerText}
        disabledBottomPanel={disabledBottomPanel}
      />
    </div>
  );
};

WidgetReleaseWithRedactor.propTypes = {
  date: PropTypes.string,
  title: PropTypes.string,
  sourse: PropTypes.string,
  text: PropTypes.string,
  onCancel: PropTypes.func,
  className: PropTypes.string,
  headerText: PropTypes.string,
  onClickOk: PropTypes.func,
  nameInput: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  newClearRelease: PropTypes.bool,
  disabledBottomPanel: PropTypes.bool,
  onClickEdit: PropTypes.func
};

export default WidgetReleaseWithRedactor;
